<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			defaultOrderBy="updated_at"
			:defaultOrderByAscending="false"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: false,
			default: "Offers",
		},
		trade: {
			type: String,
		},
	},
	data() {
		let priceIndicationFilterOptions = [
			{ id: this.__("No"), name: this.__("No") },
		].concat(
			Object.values(options.priceIndicationStatusOptions)
				.flat()
				.map((o) => {
					return {
						id: this.__(o.name),
						name: this.__(o.name),
					};
				})
		);
		console.log(priceIndicationFilterOptions);

		return {
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "company_name",
					name: this.__("Company"),
				},
				{
					id: "user_type",
					name: this.__("Type"),
					render: (t) =>
						window.__(options.getLabel(t, options.companyTypeOptions)) ??
						window.__("Others"),
				},
				{
					id: "product__grade",
					name: this.__("Article"),
					render: (grade) =>
						window.__(options.getLabel(grade, options.productGradeOptions)),
					filterOptions: Object.values(options.productGradeOptions)
						.flat()
						.map((o) => {
							return {
								id: this.__(o.name),
								name: this.__(o.name),
							};
						}),
				},
				{
					id: "product__harvest",
					name: this.__("Harvest"),
					filterOptions: this.$cropOptions.harvestYearOptions.map((y) => {
						return {
							id: y,
							name: y,
						};
					}),
				},
				{
					id: "qty__mt",
					name: this.__("Quantity"),
				},
				{
					id: "price__mt",
					name: this.__("Price"),
					render: (price, row) =>
						row.price__type == "INDEXED" ? price + " Pr" : price,
				},
				{
					id: "_auction__enabled",
					hidden: this.trade != "SELL",
					name: this.__("Auktion"),
					render: (isEnabled) => {
						return isEnabled ? window.__("Yes") : window.__("No");
					},
					filterOptions: [
						{ id: this.__("Yes"), name: this.__("Yes") },
						{ id: this.__("No"), name: this.__("No") },
					],
				},
				{
					id: "auction__qty_mt",
					hidden: this.trade != "SELL",
					name: this.__("Auction Qty"),
				},
				{
					id: "auction__price",
					hidden: this.trade != "SELL",
					name: this.__("Auction Price"),
					// render: (price, row) =>
				},
				{
					id: "visible",
					name: this.__("Visible"),
					render: (vis) => {
						return vis ? window.__("Yes") : window.__("No");
					},
					filterOptions: [
						{ id: this.__("Yes"), name: this.__("Yes") },
						{ id: this.__("No"), name: this.__("No") },
					],
				},
				{
					id: "priceindication__enabled",
					hidden: this.trade != "BUY",
					name: this.__("Flächengebot"),
					render: (x, row) =>
						row.priceindication__enabled
							? window.__(
									options.getLabel(
										row.priceindication__status,
										options.priceIndicationStatusOptions
									)
							  )
							: this.__("No"),
					filterOptions: priceIndicationFilterOptions,
				},
				{
					id: "thread_count_NEG",
					name: "#VH",
					render: (x, row) => `${row.thread_count.UNDER_NEGOTIATION}`,
				},
				{
					id: "thread_count_AGR",
					name: "#KTR",
					render: (x, row) => `${row.thread_count.CONTRACT_AGREED}`,
				},
				{
					id: "thread_count_CLOSED",
					name: "#TOT",
					render: (x, row) => `${row.thread_count.CLOSED}`,
				},
				{
					id: "location_mode",
					name: this.__("Location"),
					render: (x, tradable) =>
						window.__(
							options.getLabel(
								tradable.location__mode,
								options.locationModeOptions
							)
						),
				},
				{
					id: "location_desc",
					name: this.__("City"),
				},
				{
					id: "location__hub",
					name: this.__("Market"),
					render: (hub, row) =>
						row.location__hub == null ? __("Cash market") : __("Paper market"),
					filterOptions: [
						{ id: this.__("Cash market"), name: this.__("Cash market") },
						{ id: this.__("Paper market"), name: this.__("Paper market") },
					],
				},
				{
					id: "date_mode",
					name: this.__("Fulfilment Date"),
					render: (x, tradable) =>
						window.__(
							options.getLabel(tradable.date__type, options.dateModeOptions)
						),
					filterOptions: this.$cropOptions.dateModeOptions.map((o) => {
						return {
							id: __(o.name),
							name: __(o.name),
						};
					}),
				},
				{
					id: "date_range",
					name: this.__("Period"),
				},
				{
					id: "updated_at",
					name: this.__("Updated"),
					render: (x) => options.formatIsoStamp(x),
				},
				{
					id: "created_at",
					name: this.__("Created"),
					render: (x) => options.formatIsoStamp(x),
				},
				{
					id: "user_id",
					name: this.__("User ID"),
				},
			].filter((c) => c.hidden != true),
		};
	},
	methods: {
		rowHref(row) {
			return this.$route(
				this.trade == "BUY"
					? "admin.offers_buy_show"
					: "admin.offers_sell_show",
				{
					id: row.id.replace("#", ""),
				}
			);
		},
	},
};
</script>
